import moment from 'moment';
import { useRef } from 'react';

import { generateSolaforcePDFFromReact } from '~/utils/generatePDF';
import { getExportFileName } from '~/utils/helper';

type PropsType = {
  title: string;
  subtitle?: string;
  startDate?: Date;
  endDate?: Date;
  rowsCount: number;
};

export const useEmployeeCalendarPDFExport = (props: PropsType) => {
  const { title, subtitle, startDate, endDate, rowsCount } = props;

  const pdfRef = useRef<HTMLElement>(null);

  const onCalendarPDFExport = () => {
    const content = pdfRef.current;

    const getCalendarElementHeight = (className: string): number =>
      !!content
        ? content.getElementsByClassName(className)[0]?.clientHeight ?? 0
        : 0;

    const calendarFramingElementsHeight =
      getCalendarElementHeight('calendar-header') +
      getCalendarElementHeight('calendar-legend') +
      10;

    const resolveSubtitle = () => {
      if (!!subtitle) {
        return subtitle;
      }
      if (
        !!startDate &&
        !!endDate &&
        moment(startDate).diff(moment(endDate), 'day') !== 0
      ) {
        return `${moment(startDate).format('L')} - ${moment(endDate).format(
          'L',
        )}`;
      }
      if (!!startDate) {
        return moment(startDate).format('L');
      }
      return undefined;
    };

    if (!!content) {
      generateSolaforcePDFFromReact({
        fileName: getExportFileName({
          title,
          startDate,
          endDate,
        }),
        documentDetails: {
          title,
          subtitle: resolveSubtitle(),
        },
        contentSize: {
          height: rowsCount * 30 + calendarFramingElementsHeight,
        },
        content,
      });
    }
  };

  return {
    pdfRef,
    onCalendarPDFExport,
  };
};
